import React, { useCallback, useEffect, useState } from 'react';
import { Button, TextArea } from '@patternfly/react-core';
import useBoolean from '../../../utils/hooks/useBoolean';
import EditItemModal from '../../Modals/EditItemModal';
import ComponentPropTypes from './ComponentPropTypes';

const SubDialog = ({ title, model, isOpen, onSave, onCancel, editContent, updatedContent }) => {
  const [content, setContent] = useState(null);


  const resetState = useCallback(() => {
    setContent(null);
  }, []);

  useEffect(() => {
    if (!isOpen) {
      resetState();
    }
  }, [isOpen, resetState]);

  useEffect(() => {
    if (editContent) {
      setContent({ ...editContent });
    } else {
      resetState();
    }
  }, [editContent, resetState]);

  useEffect(() => {
    updatedContent?.(content);
  }, [content, updatedContent]);

  return (
    <EditItemModal
      isOpen={isOpen}
      title={title}
      onSave={onSave}
      onCancel={onCancel}
      item={content}
      setItem={setContent}
      models={model}
    />
  );
};

const SubDialogComponent = ({ model, value, onChange }) => {
  const [isSubDialogOpen, openSubDialog, closeSubDialog] = useBoolean(false);
  const [dialogContent, setDialogContent] = useState(value);

  const _onChange = useCallback(newValue => {
    setDialogContent(newValue);
    onChange(model, newValue);
    closeSubDialog();
  }, [closeSubDialog, model, onChange]);

  useEffect(() => {
    setDialogContent(value);
  }, [value]);

  return (
    <>
      <SubDialog
        model={model.subDialogModel}
        title={model.subDialogTitle}
        isOpen={isSubDialogOpen}
        onSave={_onChange}
        onCancel={closeSubDialog}
        editContent={dialogContent}
      />
      <TextArea
        value={JSON.stringify(dialogContent)}
        id={model.path}
        autoResize
        resizeOrientation="vertical"
      />
      <Button onClick={openSubDialog}>Select signals</Button>
    </>);
};

SubDialogComponent.propTypes = ComponentPropTypes;

export default SubDialogComponent;
